// extracted by mini-css-extract-plugin
export var hideEditor = "_nc-2";
export var infoIcon = "_nc-3";
export var label = "_nc-1";
export var labelContainer = "_nc-0";
export var readonlyText = "_nc-4";